module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/homepage/section-texture-2ecd5b2368fabe7487c2de0de58c3c6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/homepage/section-texture.jpg
// module id = FIsR
// module chunks = 12